// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Import Sentry first for error tracking
import "./sentry"

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "./sort/index"

import "./modal/mypage/resume_wish"
import "./modal/mypage/search_query"
require('jquery')
window.$ = jQuery;

Rails.start()
ActiveStorage.start()

import "./search_school"
import "./select_occupation"
import "./select_industry"
import "./photo_upload"
